import {Component, OnInit} from '@angular/core';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {_windowUtil} from "../../utils/ui-utils"
import { properties } from 'src/environments/properties';

declare let $: any;
declare let AB: any;

@Component({
    selector: 'app-freshpass-faq',
    templateUrl: './freshpass-faq.component.html',
    styleUrls: ['./freshpass-faq.component.scss'],
    providers: [SubscriptionService]
})
export class FreshpassFaqComponent implements OnInit {
    currentEnvironment;
    frequentlyAskedQuestion = '';
    public windowUtil = _windowUtil(window);
    properties = properties;

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;
    
    constructor(
        public subscriptionService: SubscriptionService) {
    }
  
    ngOnInit(): void {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.subscriptionService.getFrequentlyAskedComponent(this.currentEnvironment).subscribe(data => {
            if (data) {
                this.frequentlyAskedQuestion = data;
                setTimeout(() => {
                    // Add inactive-header to all accordion headers
                    const headers = document.querySelectorAll('.accordion-header');
                    headers.forEach(header => header.classList.add('inactive-header'));
                    // Add role="text" to .addRole elements
                    const addRoleEls = document.querySelectorAll('.addRole');
                    addRoleEls.forEach(el => el.setAttribute('role', 'text'));
                    // Handle display types
                    const displayTypes = document.querySelectorAll('.display-type');
                    displayTypes.forEach((el: Element) => {
                        const displayType = el.getAttribute('data-display-type');
                        const headerEls = el.querySelectorAll('.accordion-header');
                        const contentEls = el.querySelectorAll('.accordion-content');
                        if (displayType === 'expandFirst' && headerEls.length > 0 && contentEls.length > 0) {
                            headerEls[0].classList.add('active-header');
                            headerEls[0].classList.remove('inactive-header');
                            contentEls[0].classList.add('open-content');
                            (contentEls[0] as HTMLElement).style.display = 'block';
                        } else if (displayType === 'expanded') {
                            headerEls.forEach(header => {
                                header.classList.add('active-header');
                                header.classList.remove('inactive-header');
                            });
                            contentEls.forEach(content => {
                                content.classList.add('open-content');
                                (content as HTMLElement).style.display = 'block';
                            });
                        }
                    });
                    // Set aria-expanded and add event listeners
                    headers.forEach(header => {
                        header.setAttribute('aria-expanded', header.classList.contains('active-header') ? 'true' : 'false');
                        header.addEventListener('click', () => {
                            const isInactive = header.classList.contains('inactive-header');
                            header.classList.toggle('active-header', isInactive);
                            header.classList.toggle('inactive-header', !isInactive);
                            header.setAttribute('aria-expanded', isInactive ? 'true' : 'false');
                            const nextContent = header.nextElementSibling;
                            if (nextContent && nextContent.classList.contains('accordion-content')) {
                                nextContent.classList.toggle('open-content');
                                (nextContent as HTMLElement).style.display = nextContent.classList.contains('open-content') ? 'block' : 'none';
                            }
                        });
                        header.addEventListener('keypress', (e: KeyboardEvent) => {
                            if (e.key === 'Enter' || e.which === 13) {
                                const isInactive = header.classList.contains('inactive-header');
                                header.classList.toggle('active-header', isInactive);
                                header.classList.toggle('inactive-header', !isInactive);
                                header.setAttribute('aria-expanded', isInactive ? 'true' : 'false');
                                const nextContent = header.nextElementSibling;
                                if (nextContent && nextContent.classList.contains('accordion-content')) {
                                    nextContent.classList.toggle('open-content');
                                    (nextContent as HTMLElement).style.display = nextContent.classList.contains('open-content') ? 'block' : 'none';
                                }
                            }
                        });
                    });
                }, 2000);
            }
        });
    }

    openManageFreshpass() {
        this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.MANAGE_PLAN_PATH);
    }

    openHomepage() {
        this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.SHOP_HOME_PATH);
    }
}
